import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import StatusSelect from "../../../components/CustomSelect/StatusSelect";
import CustomInput from "../../../components/CustomInput/CustomInput";
import { editMaintenanceOffer } from "../../../redux/Maintenance/MaintenanceOffers/maintenanceOffersSlice";
import CustomDatePicker from "../../../components/CustomDatePicker";
import { base_url } from "../../../helpers/Constants";

function EditMaintenanceOffer() {
  const dispatch = useDispatch();
  const { editMaintenanceOfferFormValues } = useSelector(
    (state) => state.maintenanceOffers
  );

  const {
    register,
    formState: { errors, isDirty },
    handleSubmit,
    reset,
    control,
  } = useForm({
    defaultValues: editMaintenanceOfferFormValues,
  });

  useEffect(() => {
    reset(editMaintenanceOfferFormValues);
  }, [editMaintenanceOfferFormValues]);

  // Preview selected image
  const [image, setImage] = useState();
  const handleImageChange = (e) => {
    setImage(URL.createObjectURL(e.target.files[0]));
  };

  const handleEditMaintenanceOffer = (data) => {
    const formData = new FormData();

    for (let key in data) {
      key === "imageFile"
        ? formData.append(key, data[key][0])
        : formData.append(key, data[key]);
    }

    dispatch(editMaintenanceOffer({ formData, id: data.id }));
  };

  return (
    <>
      <nav className="uk-position-relative" aria-label="Breadcrumb">
        <ul className="uk-breadcrumb">
          <li>
            <span>الصيانة</span>
          </li>
          <li>
            <NavLink to="/MaintenanceOffers">عروض الصيانة</NavLink>
          </li>
          <li>
            <span aria-current="page">تعديل عرض</span>
          </li>
        </ul>
      </nav>

      <div className="uk-padding-small uk-background-default uk-border-rounded">
        <form className="uk-grid-small uk-child-width-1-2" uk-grid="">
          <div>
            <label className="uk-form-label uk-text-gray uk-text-bold">
              الإسم بالعربي
            </label>
            <div className="uk-form-controls uk-margin-small-top">
              <CustomInput
                control={control}
                name="nameAr"
                error={errors.nameAr}
              />
            </div>
          </div>
          <div>
            <label className="uk-form-label uk-text-gray uk-text-bold">
              الإسم بالإنجليزي
            </label>
            <div className="uk-form-controls uk-margin-small-top">
              <CustomInput
                control={control}
                name="nameEn"
                error={errors.nameEn}
              />
            </div>
          </div>
          <div>
            <label className="uk-form-label uk-text-gray uk-text-bold">
              الوصف بالعربي
            </label>
            <div className="uk-form-controls uk-margin-small-top">
              <CustomInput
                control={control}
                name="descriptionAr"
                error={errors.descriptionAr}
                textarea
              />
            </div>
          </div>
          <div>
            <label className="uk-form-label uk-text-gray uk-text-bold">
              الوصف بالإنجليزي
            </label>
            <div className="uk-form-controls uk-margin-small-top">
              <CustomInput
                control={control}
                name="descriptionEn"
                error={errors.descriptionEn}
                textarea
              />
            </div>
          </div>
          <div>
            <label className="uk-form-label uk-text-gray uk-text-bold">
              بداية العرض
            </label>
            <div className="uk-form-controls uk-margin-small-top">
              <CustomDatePicker
                control={control}
                name="offer_start"
                error={errors.offer_start}
              />
            </div>
          </div>
          <div>
            <label className="uk-form-label uk-text-gray uk-text-bold">
              نهاية العرض
            </label>
            <div className="uk-form-controls uk-margin-small-top">
              <CustomDatePicker
                control={control}
                name="offer_end"
                error={errors.offer_end}
              />
            </div>
          </div>
          <div>
            <label className="uk-form-label uk-text-gray uk-text-bold">
              السعر قبل الخصم
            </label>
            <div className="uk-form-controls uk-margin-small-top">
              <CustomInput
                control={control}
                name="price_before"
                error={errors.price_before}
                type="number"
              />
            </div>
          </div>
          <div>
            <label className="uk-form-label uk-text-gray uk-text-bold">
              السعر بعد الخصم
            </label>
            <div className="uk-form-controls uk-margin-small-top">
              <CustomInput
                control={control}
                name="price_after"
                error={errors.price_after}
                type="number"
              />
            </div>
          </div>
          <div>
            <label className="uk-form-label uk-text-gray uk-text-bold">
              نسبة الخصم
            </label>
            <div className="uk-form-controls uk-margin-small-top">
              <CustomInput
                control={control}
                name="offer_discount"
                error={errors.offer_discount}
                type="number"
              />
            </div>
          </div>
          <div>
            <label className="uk-form-label uk-text-gray uk-text-bold">
              الترتيب
            </label>
            <div className="uk-form-controls uk-margin-small-top">
              <CustomInput
                control={control}
                name="order"
                error={errors.order}
                type="number"
              />
            </div>
          </div>
          <div>
            <label className="uk-form-label uk-text-gray uk-text-bold">
              الحالة
            </label>
            <div className="uk-form-controls uk-margin-small-top">
              <Controller
                name="status"
                control={control}
                render={({ field }) => (
                  <StatusSelect field={field} error={errors.status} />
                )}
                rules={{
                  validate: (v) => typeof v == "boolean" || "هذا الحقل مطلوب!",
                }}
              />
            </div>
          </div>
          <div>
            <label className="uk-form-label uk-text-gray uk-text-bold">
              الصورة
            </label>
            <div className="uk-form-controls uk-margin-small-top">
              <div uk-form-custom="">
                <input
                  type="file"
                  aria-label="Custom controls"
                  name="imageFile"
                  {...register("imageFile", {
                    onChange: handleImageChange,
                    validate: image && {
                      lessThan2MB: (files) =>
                        files[0]?.size < 2000000 ||
                        "لا يجب أن يتعدى حجم الصورة 2 ميجا بايت",
                      acceptedFormats: (files) =>
                        ["image/jpg", "image/png", "image/jpeg"].includes(
                          files[0]?.type
                        ) || "يجب أن تكون صيغة الصورة JPG, PNG, JPEG",
                    },
                  })}
                  aria-invalid={errors.imageFile ? "true" : "false"}
                />
                <button
                  className="uk-button uk-button-default uk-border-rounded"
                  type="button"
                  tabIndex="-1"
                >
                  إختر صورة
                </button>
                <img
                  src={
                    image ??
                    `${base_url}/${editMaintenanceOfferFormValues?.imageFile}`
                  }
                  alt="Selected image"
                  className="uk-height-max-small uk-border-rounded uk-margin-small-right uk-align-left"
                />
              </div>
              {errors.imageFile && (
                <small className="uk-text-danger uk-display-block uk-margin-small-top">
                  <span
                    className="uk-margin-small-left"
                    uk-icon="warning"
                  ></span>
                  {errors.imageFile.message}
                </small>
              )}
            </div>
          </div>
        </form>
        <div className="uk-margin-top uk-text-left">
          <button
            className="uk-button uk-button-secondary uk-margin-small-left uk-border-rounded"
            type="button"
            disabled={!isDirty}
            onClick={handleSubmit(handleEditMaintenanceOffer)}
          >
            تعديل
          </button>
          <NavLink
            to="/MaintenanceOffers"
            className="uk-button uk-button-primary uk-modal-close uk-border-rounded"
            type="button"
          >
            إلغاء
          </NavLink>
        </div>
      </div>
    </>
  );
}

export default EditMaintenanceOffer;
